import React from 'react';

import { ContentMetricItem, DrawerMetricItem, FooterMetricItem } from './MetricItem.styles';

type MetricItemVariant = 'content' | 'footer' | 'drawer';

interface MetricItemProps {
  variant: MetricItemVariant;
  label: React.ReactNode;
  value: React.ReactNode;
  unit?: React.ReactNode;
}

export const MetricItem = ({ variant, label, value, unit }: MetricItemProps) => {
  if (variant === 'content') {
    return (
      <ContentMetricItem>
        <div className="label">{label}</div>
        <div className="value-row">
          <span className="value">{value}</span>
          {unit ? <span className="unit">{unit}</span> : null}
        </div>
      </ContentMetricItem>
    );
  }

  if (variant === 'drawer') {
    return (
      <DrawerMetricItem>
        <div className="label">{label}</div>
        <div className="value-row">
          <span className="value">{value}</span>
          {unit ? <span className="unit">{unit}</span> : null}
        </div>
      </DrawerMetricItem>
    );
  }

  return (
    <FooterMetricItem>
      <div className="label">{label}</div>
      <div className="value-row">
        <span className="value">{value}</span>
        {unit ? <span className="unit">{unit}</span> : null}
      </div>
    </FooterMetricItem>
  );
};
